import React, { Component, Fragment } from 'react'
import AOS from "aos";
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../../Actions/Config'
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import Helmet from '../Common/Helmet'
import TourListing from "../Common/TourListing"
import HyperLinkThingsToDo from "./HyperLinkThingsToDo"
import { getHyperLinkTypeTours } from "../../Actions/TourAction"
import "aos/dist/aos.css";

const mapStateToProps = (state) => {
    return {
        tour: state.Tour
    }
}

const mapDispatchToProps = dispatch => ({
    getHyperLinkTypeTours: (type, peram) => dispatch(getHyperLinkTypeTours(type, peram))
});


function getURL(tour) {
    var url = ""
    switch (tour.tour) {
        case "Day tour":
            url = "/day-tours/" + tour.permalink + "/" + tour.id
            break;
        case "Round tour":
            url = "/round-tours/" + tour.itinerary_category.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '') + "/" + "tour.permalink"
            break;

        default:
            break;
    }
    return url
}


function getBackgroudImage(tour) {
    var image = ""
    switch (tour.tour) {
        case "Day tour":
            image = tour.listing_image != undefined && tour.listing_image != '' ? tour.listing_image : API_URL + tour.banner_image
            break;
        case "Round tour":
            image = tour.home_image != undefined && tour.home_image != '' ? API_URL + tour.home_image : API_URL + tour.itinerary_images.thumb
            break;
        case "Maldive tour":
            image = tour.home_image.thumb
            break;
        default:
            break;
    }
    return image
}

class HyperLinkListPage extends Component {

    constructor(props) {
        super(props);

        const { type, peram } = this.props.match.params;
        this.state = {

        }
        this.props.getHyperLinkTypeTours(type, peram)
    }

    componentDidMount() {

        AOS.init({
            duration: 800,
            once: true
        });

        window.scrollTo(0, 0)
    }

    render() {
        const { hyperLinkTours, hyperLinkDetail } = this.props.tour;

        return <Fragment id="loader-overlay" className='blur'>
            <Header home={false} />

            <Helmet
                title={hyperLinkDetail.title}
                description={hyperLinkDetail.meta_description}
            />

            <div className="page-title">
                <div className="container title-cont">
                    <div className="row">
                        <div className="col-lg-12 title-inner">
                            <div className="breadcrumb-links">
                                <a href="/">Home</a> <span className="sep"></span>Links
                                <span className="sep"></span> {hyperLinkDetail.title}
                            </div>
                            <h1 id="tour-title">{hyperLinkDetail.title}</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div id="loadDayTour" style={{ backgroundColor: "#f8f8f8", minHeight: "60vh" }}>
                {hyperLinkDetail.tour_type != 2 ? <div id="myDiv">
                    <div className="maindiv" >
                        <div className="container">
                            <div className="row day-tour-row">
                                {hyperLinkTours.length > 0 ? hyperLinkTours.map((tour, index) => (<TourListing
                                    {...this.props}
                                    index={index}
                                    url={getURL(tour)}
                                    bgImage={getBackgroudImage(tour)}
                                    tour={tour}
                                    tourCount={hyperLinkTours.length}
                                    key={index + 1}
                                />))
                                    : null}
                            </div>
                        </div>
                    </div>
                </div> :
                    <div id="myDiv">
                        <div className="maindiv" >
                            <div className="container">
                                <div className="row day-tour-row">
                                    {hyperLinkTours.length > 0 ? hyperLinkTours.map((tour, index) => (<HyperLinkThingsToDo
                                        {...this.props}
                                        index={index}
                                        tour={tour}
                                        tourCount={hyperLinkTours.length}
                                        key={index + 1}
                                    />))
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>

                }

            </div>


            <Footer hyperLink={true} />
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(HyperLinkListPage);